/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ESSOImageStatus } from "../types/ESSOImageStatus.ts";

/**
 * @description 1 = Draft | 2 = Publish |
 */
export const ESSOImageStatusSchema = z
  .union([z.literal(1), z.literal(2)])
  .describe("1 = Draft | 2 = Publish | ") as unknown as ToZod<ESSOImageStatus>;
